import { Link } from "@tanstack/react-router"
import { PublicationPreviewProps } from "../../api/landingpage"
import { Blockquote, Box, Card, Float, Image, Text, useBreakpointValue } from "@chakra-ui/react"


const LeadPublicationPreview = ({publication} : PublicationPreviewProps) => {
    const isMobile = useBreakpointValue({ base: true, md: false })

    return (
        <Link to="/$slug" params={{ slug: publication.classic_id }}>
            <Card.Root w="100%">
                <Card.Header pos="relative" p={0}>
                {publication.lead_image ? (
                    <Image
                        src={isMobile ? publication.lead_image.path.replace(/-(LG)\./, "-MD.") : publication.lead_image.path}
                        alt={publication.lead_image.file_name}
                        borderRadius="md"
                        h="25em"
                        objectFit="cover"
                        objectPosition={`${publication.lead_image.focal_point ? publication.lead_image.focal_point[0] : 50}% ${publication.lead_image.focal_point ? publication.lead_image.focal_point[1] : 50}%`}
                    />
                ) : (
                    <Box borderRadius="md" h="25em" bgColor="main"></Box>
                )}

                <Float
                    display="block"
                    pos="absolute"
                    top={3}
                    left={-3}
                    translate="none"
                    backgroundColor="mainOpacity"
                    color="white"
                    px={5}
                    py={2}
                    w="fit-content"
                    boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px"
                >
                    <Text hyphens="auto" data-testid="publication_card_subtitle" fontWeight="bold">
                        {publication.subtitle && publication.subtitle != "" ? publication.subtitle : publication.fk_categories.at(0)?.name}
                    </Text>
                </Float>

                <Box
                    position="absolute"
                    bottom="0"
                    left="0"
                    right="0"
                    height="50%"
                    bg="linear-gradient(
                        0deg,
                        rgba(0, 0, 0, 0.7) 0%,
                        rgba(0, 0, 0, 0.55) 40%,
                        rgba(0, 0, 0, 0.25) 75%,
                        rgba(0, 0, 0, 0) 100%
                    );"
                    pointerEvents="none"
                    borderBottomLeftRadius="md"
                    borderBottomRightRadius="md"
                />

                <Float
                    display="block"
                    pos="absolute"
                    bottom={10}
                    left={2}
                    translate="none"
                    color="secondary"
                    h="fit-content"
                    insetBlockStart="auto"
                >
                    <Blockquote.Root borderInlineStartColor="main">
                        <Blockquote.Content
                            fontSize={{sm: "14pt", md: "24pt"}}
                            fontWeight="bold"
                        >
                            {publication.title}
                        </Blockquote.Content>
                    </Blockquote.Root>
                </Float>
                </Card.Header>
            </Card.Root>
        </Link>
    )
}

export default LeadPublicationPreview
